/**
 * Location URL mapping - maps location IDs to URL slugs
 * This ensures URLs match the existing site structure
 */

/** Display names for forms (Contact, Feedback, Cancellation) in desired order */
export const LOCATION_DISPLAY_NAMES = {
  "giant-fitness-clementon": "Clementon",
  "giant-fitness-voorhees": "Voorhees",
  "giant-fitness-woodbury-heights": "Woodbury Heights",
  "giant-fitness-philadelphia": "Philadelphia",
  "giant-fitness-mount-ephraim": "Mt Ephraim",
  "jersey-girls-westville": "Jersey Girls Westville",
  "jersey-girls-blenheim": "Jersey Girls Blenheim",
  "giant-fitness-moorestown": "Moorestown",
};

export const LOCATION_FORM_ORDER = [
  "giant-fitness-clementon",
  "giant-fitness-voorhees",
  "giant-fitness-woodbury-heights",
  "giant-fitness-philadelphia",
  "giant-fitness-mount-ephraim",
  "jersey-girls-westville",
  "jersey-girls-blenheim",
  "giant-fitness-moorestown",
];

export function getLocationDisplayName(locationId) {
  return LOCATION_DISPLAY_NAMES[locationId] ?? null;
}

export const LOCATION_URL_MAP = {
  "giant-fitness-voorhees": "giant-fitness-voorhees-nj",
  "giant-fitness-philadelphia": "philadelphia",
  "giant-fitness-clementon": "gloucester-township-nj",
  "jersey-girls-blenheim": "blenheim-new-jersey-women-only",
  "giant-fitness-moorestown": "moorestown-new-jersey",
  "giant-fitness-woodbury-heights": "giant-fitness-woodbury-heights-nj",
  "giant-fitness-mount-ephraim": "mt-ephraim",
  "jersey-girls-westville": "jersey-girls-women-only-westville-nj",
};

// Special case: /phillygirls/ maps to giant-fitness-philadelphia (same location, different URL)
// /blackwood maps to Jersey Girls Blenheim (Blackwood, NJ)
export const SLUG_ALIASES = {
  "phillygirls": "giant-fitness-philadelphia",
  "blackwood": "jersey-girls-blenheim",
  "jersey-girls-women-only-voorhees-nj": "jersey-girls-westville",
};

// Reverse mapping: slug -> location ID
export const SLUG_TO_ID_MAP = Object.fromEntries(
  Object.entries(LOCATION_URL_MAP).map(([id, slug]) => [slug, id])
);

/**
 * Get URL slug for a location ID
 */
export function getLocationUrl(locationId) {
  return LOCATION_URL_MAP[locationId] || locationId;
}

/**
 * Get location ID from URL slug
 */
export function getLocationIdFromSlug(slug) {
  // Check aliases first (e.g., phillygirls -> giant-fitness-philadelphia)
  if (SLUG_ALIASES[slug]) {
    return SLUG_ALIASES[slug];
  }
  return SLUG_TO_ID_MAP[slug] || slug;
}

/**
 * Get full location URL path
 */
export function getLocationPath(locationId) {
  const slug = getLocationUrl(locationId);
  return `/${slug}/`;
}
